import { TEquityInfoKS } from '@commenda/types/src/incorporation/types';
import { CorporationType } from '@prisma/client';
import { TShareholderVsSharePercentageMap } from '../../EquityInfo/types';

export const generateOwnershipSummaryTableRowsForUSEntities = ({
  equityInfo,
  selectedStakeholders,
  corporationType,
  hasESOPs,
}: {
  equityInfo: TEquityInfoKS;
  selectedStakeholders: TShareholderVsSharePercentageMap;
  corporationType: CorporationType;
  hasESOPs: boolean;
}) => {
  const esopPool = equityInfo.shareRetained || 0;
  const ownershipPool = 100 - esopPool;
  const price = equityInfo.price || 0;

  let totalOwnership = 0;
  let totalActualOwnership = 0;
  let totalShares = 0;

  const ownershipSummaryTableRows = Object.values(
    selectedStakeholders || {}
  ).map((stakeholder) => {
    const actualOwnership =
      hasESOPs && corporationType === CorporationType.CCorp
        ? (ownershipPool * stakeholder.sharePercentage) / 100
        : stakeholder.sharePercentage;
    totalOwnership += stakeholder.sharePercentage || 0;
    totalActualOwnership += actualOwnership;
    totalShares += Math.round((equityInfo.shareCount * actualOwnership) / 100);
    return {
      id:
        stakeholder.type === 'INDIVIDUAL'
          ? `INDIVIDUAL_${stakeholder.id}`
          : `INSTITUTION_${stakeholder.id}`,
      name: stakeholder.name,
      ownership: stakeholder.sharePercentage
        ? stakeholder.sharePercentage.toFixed(2)
        : '',
      actualOwnership: actualOwnership ? actualOwnership.toFixed(2) : '',
      esopContribution:
        ((esopPool * stakeholder.sharePercentage) / 100)?.toFixed(2) || '',
      shares: stakeholder.shareCount.toLocaleString(),
      shareCount: stakeholder.shareCount,
      shareValue: stakeholder.shareCount * price,
    };
  });

  const esopShares = Math.round((equityInfo.shareCount * esopPool) / 100);

  if (hasESOPs && corporationType === CorporationType.CCorp) {
    ownershipSummaryTableRows.push({
      id: '-1',
      name: 'ESOP Shares',
      ownership: '',
      actualOwnership: '',
      esopContribution: '',
      shares: esopShares.toLocaleString(),
      shareCount: esopShares,
      shareValue: esopShares * price,
    });
  }

  const totalShareCount = totalShares + (hasESOPs ? esopShares : 0);
  ownershipSummaryTableRows.push({
    id: '-2',
    name: 'Total',
    ownership: totalOwnership.toFixed(2),
    actualOwnership: totalActualOwnership.toFixed(2),
    esopContribution: esopPool.toFixed(2),
    shares: totalShareCount.toLocaleString(),
    shareCount: totalShareCount,
    shareValue: totalShareCount * price,
  });

  return ownershipSummaryTableRows;
};
